import { render } from "./NursingReviewForm.vue?vue&type=template&id=6884189a&scoped=true"
import script from "./NursingReviewForm.vue?vue&type=script&lang=js"
export * from "./NursingReviewForm.vue?vue&type=script&lang=js"

import "./NursingReviewForm.vue?vue&type=style&index=0&id=6884189a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6884189a"]])

export default __exports__